const PLAN_POLE_TYPE = {
  PASSIVE: 'POLE_PASSIVE',
  ACTIVE: 'POLE_ACTIVE',
  ALL: 'ALL',
}

const poleName = {
  [PLAN_POLE_TYPE.PASSIVE]: 'Polo passivo',
  [PLAN_POLE_TYPE.ACTIVE]: 'Polo ativo',
  [PLAN_POLE_TYPE.ALL]: 'Todos os polos',
}

const translatePlanPole = (key) => {
  return poleName[key] || key
}

export {
  PLAN_POLE_TYPE,
  translatePlanPole,
}
